import { Toaster } from 'sonner';
import { Icon } from '@scripsteam/scrips-signal-ds';

/**
 * The app's one toast host. Owner + designer (20 Oct): coloured toasts (sonner rich colours), centred at the top, on the
 * design's tokens (showcase-booking.css `[data-sonner-toast]`: PaToast's radius, padding, gap and type, the DS status
 * pairs, the DS shadow) with the design's DS tone icons (check-circle success, warning error).
 * Only the presentation changed: every `toast.*` call, its text and timing are as before (sonner, the same host).
 */
const TOAST_ICONS = {
  success: <Icon name="check-circle" size={16} aria-hidden />,
  error: <Icon name="warning" size={16} aria-hidden />,
  warning: <Icon name="warning" size={16} aria-hidden />,
  info: <Icon name="info" size={16} aria-hidden />,
};

export function AppToaster() {
  return <Toaster position="top-center" richColors offset="var(--spacing-6)" icons={TOAST_ICONS} />;
}
